// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Pinterest: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M24 12c0 6.629-5.371 12-12 12-1.239 0-2.429-.189-3.552-.537.49-.798 1.22-2.105 1.49-3.145l.746-2.855c.392.745 1.534 1.379 2.748 1.379 3.62 0 6.228-3.33 6.228-7.466 0-3.963-3.237-6.93-7.399-6.93-5.177 0-7.93 3.475-7.93 7.264 0 1.761.938 3.953 2.434 4.65.227.106.348.058.401-.16.039-.165.242-.982.334-1.36a.36.36 0 00-.082-.343c-.489-.605-.886-1.708-.886-2.739 0-2.647 2.003-5.206 5.42-5.206 2.946 0 5.013 2.008 5.013 4.882 0 3.247-1.64 5.497-3.775 5.497-1.175 0-2.061-.973-1.775-2.168.338-1.428.991-2.966.991-3.997 0-.92-.493-1.689-1.519-1.689-1.205 0-2.172 1.244-2.172 2.913 0 1.065.358 1.781.358 1.781s-1.186 5.023-1.404 5.961c-.242 1.036-.145 2.497-.043 3.445C3.165 21.431 0 17.085 0 12 0 5.371 5.371 0 12 0s12 5.371 12 12z" />
        </svg>
    );
};

export default React.memo(Pinterest);
